import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-custom-footer',
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.scss']
})
export class CustomFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
